//winter time zones
let stdTimezones = {
    "-12:00": "Etc/GMT+12",
    "-11:00": "Pacific/Pago_Pago",
    "-10:00": "Pacific/Tahiti",
    "-09:30": "Pacific/Marquesas",
    "-09:00": "Pacific/Gambier",
    "-08:00": "Pacific/Pitcairn",
    "-07:00": "America/Fort_Nelson",
    "-06:00": "America/Costa_Rica",
    "-05:00": "America/Jamaica",
    "-04:00": "America/Puerto_Rico",
    "-03:30": "America/St_Johns",
    "-03:00": "America/Fortaleza",
    "-02:00": "Atlantic/South_Georgia",
    "-01:00": "Atlantic/Cape_Verde",
    "Z": "Etc/UTC",
    "+01:00": "Europe/Zurich",
    "+02:00": "Europe/Bucharest",
    "+03:00": "Europe/Moscow",
    "+03:30": "Asia/Tehran",
    "+04:00": "Asia/Dubai",
    "+04:30": "Asia/Kabul",
    "+05:00": "Asia/Karachi",
    "+05:30": "Asia/Kolkata",
    "+06:00": "Asia/Dhaka",
    "+06:30": "Asia/Yangon",
    "+07:00": "Asia/Jakarta",
    "+08:00": "Asia/Shanghai",
    "+09:00": "Asia/Tokyo",
    "+09:30": "Australia/Darwin",
    "+10:00": "Australia/Sydney",
    "+11:00": "Pacific/Norfolk",
    "+12:00": "Pacific/Wallis",
    "+13:00": "Pacific/Apia",
};

//daylight savings time zones
let dsTimezones = {
    "-12:00": "Etc/GMT+12",
    "-11:00": "Pacific/Pago_Pago",
    "-10:00": "Pacific/Tahiti",
    "-09:30": "Pacific/Marquesas",
    "-09:00": "Pacific/Gambier",
    "-08:00": "Pacific/Pitcairn",
    "-07:00": "America/Fort_Nelson",
    "-06:00": "America/Costa_Rica",
    "-05:00": "America/Jamaica",
    "-04:00": "America/Puerto_Rico",
    "-03:30": "America/St_Johns",
    "-03:00": "America/Fortaleza",
    "-02:00": "Atlantic/South_Georgia",
    "-01:00": "Atlantic/Cape_Verde",
    "Z": "Etc/UTC",
    "+01:00": "Europe/Dublin",
    "+02:00": "W. Europe Standard Time",
    "+03:00": "Europe/Moscow",
    "+03:30": "Asia/Tehran",
    "+04:00": "Asia/Dubai",
    "+04:30": "Asia/Kabul",
    "+05:00": "Asia/Karachi",
    "+05:30": "Asia/Kolkata",
    "+06:00": "Asia/Dhaka",
    "+06:30": "Asia/Yangon",
    "+07:00": "Asia/Jakarta",
    "+08:00": "Asia/Shanghai",
    "+09:00": "Asia/Tokyo",
    "+09:30": "Australia/Darwin",
    "+10:00": "Australia/Brisbane",
    "+11:00": "Australia/Sydney",
    "+12:00": "Pacific/Wallis",
    "+13:00": "Pacific/Auckland",
};

export {stdTimezones, dsTimezones};